<div class="modal fade" role="dialog" aria-modal="true" aria-labelledby="2faU2fTitle">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <modal-header
        [title]="'enableBiometricVerification' | i18n"
        [showBackButton]="false"
      ></modal-header>
      <div class="tw-rounded-xl tw-bg-dt-surface-card tw-p-10 xs:tw-px-5">
        <app-two-factor-verify
          *ngIf="!preVerifiedHash"
          [organizationId]="organizationId"
          [type]="type"
          (onAuthed)="auth($any($event))"
        >
        </app-two-factor-verify>
        <div *ngIf="preVerifiedHash" class="tw-flex tw-justify-center tw-p-5">
          <i class="bwi bwi-spinner bwi-spin" title="{{ 'loading' | i18n }}" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </div>
</div>
